import { useMemo } from 'react'
import { useElementType } from '@editorHooks'

type DefaultLoadTab = 'point-load' | 'line-load' | 'area-load'

const useResults2DefaultLoadTab = (elementGuid: string | null | undefined): DefaultLoadTab => {
  const elementType = useElementType(elementGuid)

  return useMemo<DefaultLoadTab>(() => {
    // Keep defaults consistent between Results2 detail pane and scene.
    if (
      elementType === 'lintels' ||
      elementType === 'beams' ||
      elementType === 'purlins' ||
      elementType === 'roof_slab_beams' ||
      elementType === 'slab_beams'
    ) {
      return 'line-load'
    }

    if (elementType === 'vertical_slabs' || elementType === 'vertical_roof_slabs') {
      return 'area-load'
    }

    return 'point-load'
  }, [elementType])
}

export default useResults2DefaultLoadTab
